import { render, staticRenderFns } from "./amenities-popup.vue?vue&type=template&id=303c88d4&scoped=true"
import script from "./amenities-popup.vue?vue&type=script&lang=js"
export * from "./amenities-popup.vue?vue&type=script&lang=js"
import style0 from "./amenities-popup.vue?vue&type=style&index=0&id=303c88d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303c88d4",
  null
  
)

export default component.exports